export default "__VITE_ASSET__CA$418nr__"